import { metricsWithPercentFormat } from 'features/EditMetrics/constants';

export function isMetricWithPercentFormat(metricId: number): boolean {
  return metricsWithPercentFormat.includes(metricId);
}
